import _ from "lodash";
import React from "react";
import styled from "styled-components";

import { Text } from "@components/Text";
import { convertFormatDate } from "@utils/convertFormatDate";

const Container = styled.div`
  width: 300px;
`;

export const ContentInfo = ({ data }) => {
  const width = _.get(data, ["screen_width"]);
  const height = _.get(data, ["screen_height"]);
  const building = _.get(data, ["floor", "building", "name"]);
  const floor = _.get(data, ["floor", "name"]);
  const playerId = _.get(data, ["player_id"]);
  const macAddress = _.get(data, ["mac_address"]);
  const versions = _.get(data, ["versions"]);
  const createAt = _.get(data, ["created_at"]);
  const description = _.get(data, ["description"]);

  return (
    <Container>
      <Text>Width : {width}px</Text>
      <Text>Height : {height}px</Text>
      <Text>Building : {building}</Text>
      <Text>Floor : {floor}</Text>
      <Text>Create At</Text>
      <Text>{convertFormatDate({ date: createAt })}</Text>
      <Text>Player ID</Text>
      <Text>{_.isNil(playerId) ? "-" : playerId}</Text>
      <Text>Mac Address</Text>
      <Text>{_.isNil(macAddress) ? "-" : _.toUpper(macAddress)}</Text>
      <Text>Versions</Text>
      <Text>{_.isNil(versions) ? "-" : _.toUpper(versions)}</Text>
      <Text>description</Text>
      <Text>{_.isNil(description) ? "-" : description}</Text>
    </Container>
  );
};
